import { Component, OnInit, ViewEncapsulation, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'page-not-found',
    templateUrl: 'page.not.found.component.html',
    styleUrls: ['page.not.found.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageNotFoundComponent implements OnInit {
    @HostBinding('class.modern-form') modern = true;

    constructor(private router: Router) { }

    ngOnInit() { }

    onGoHome() {
        this.router.navigate(['/home']);
    }
}